const checkbox = {};

checkbox.generic = () => {
    const $checkboxContainer = document.getElementById("js-checkboxes-container");
    if($checkboxContainer){
        let $checkboxesList = $checkboxContainer.querySelectorAll('input[type=checkbox]');
        let $proceedButton  = document.getElementById("button-proceed");
        let $skipButton  = document.getElementById("button-skip-step");

        for (let i=0;i<$checkboxesList.length;i++) {
            let checkboxBox = $checkboxesList[i].parentNode;
            $checkboxesList[i].addEventListener('change', function() {
                if($proceedButton){
                    let $activeCheckboxestNumber = $checkboxContainer.querySelectorAll('input[type=checkbox]:checked').length;
                    if($activeCheckboxestNumber>=1) {
                        $proceedButton.style.display = 'block';
                        $skipButton.style.display = 'none';
                    } else {
                        $skipButton.style.display = 'block';
                        $proceedButton.style.display = 'none';
                    }
                }
                if (this.checked) {
                    anchorItem(checkboxBox);
                }
            });
        }

    }

    function anchorItem(checkboxBox){
        const yOffset = -100;
        const y = checkboxBox.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});

    }
}

checkbox.init = () => {
    checkbox.generic();
}

export default checkbox;
